import { render, staticRenderFns } from "./aboutus-maskEx.vue?vue&type=template&id=4ae13cf0&"
import script from "./aboutus-maskEx.vue?vue&type=script&lang=js&"
export * from "./aboutus-maskEx.vue?vue&type=script&lang=js&"
import style0 from "./aboutus-maskEx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports